module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        Average amount of fees per block in USD.\n    ")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('stat-table', {
    attrs: {
      "stats": _vm.stats
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-fees"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25f6063c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/fees.vue
// module id = 532
// module chunks = 1